export enum UserLevel {
  MASTER = 1,
  FULL = 2,
  ADMIN = 3,
  OWNER = 4,
  USER = 5
}